module.exports = __webpack_public_path__ + "static/img/br.6827f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/flag/br.png
// module id = 8ry3
// module chunks = 0